/** The Preferences section registry: ids, labels, icons and native symbols in one list, so the sidebar, the mobile list and the header title cannot disagree. */
import {
  Bell, Clock, Eye, Globe, LayoutList, Lock, MessageSquare, Palette, Settings2, Star,
  type LucideIcon,
} from '@/shared/ui/icons';
import type { PreferenceSectionId } from './preferenceSectionIds';

export { PREFERENCE_SECTION_IDS, isPreferenceSectionId, type PreferenceSectionId } from './preferenceSectionIds';

export interface PreferenceSectionDefinition {
  id: PreferenceSectionId;
  label: string;
  icon: LucideIcon;
  sfSymbol: string;
}

export const PREFERENCE_SECTIONS: readonly PreferenceSectionDefinition[] = [
  { id: 'availability', label: 'Availability', icon: Clock, sfSymbol: 'clock.fill' },
  { id: 'notifications', label: 'Notifications', icon: Bell, sfSymbol: 'bell.fill' },
  { id: 'priority-contacts', label: 'Priority contacts', icon: Star, sfSymbol: 'star.fill' },
  { id: 'navigation', label: 'Navigation', icon: LayoutList, sfSymbol: 'sidebar.left' },
  { id: 'appearance', label: 'Appearance', icon: Palette, sfSymbol: 'paintpalette.fill' },
  { id: 'messages', label: 'Messages', icon: MessageSquare, sfSymbol: 'message.fill' },
  { id: 'region', label: 'Language and region', icon: Globe, sfSymbol: 'globe' },
  { id: 'accessibility', label: 'Accessibility', icon: Eye, sfSymbol: 'accessibility' },
  { id: 'privacy', label: 'Privacy', icon: Lock, sfSymbol: 'hand.raised.fill' },
  { id: 'advanced', label: 'Advanced', icon: Settings2, sfSymbol: 'gearshape.2.fill' },
];

export const DEFAULT_PREFERENCE_SECTION: PreferenceSectionId = 'availability';

export function getPreferenceSectionLabel(id: string | null | undefined): string | null {
  return PREFERENCE_SECTIONS.find(section => section.id === (id === 'mark-as-read' ? 'messages' : id))?.label ?? null;
}
